// extracted by mini-css-extract-plugin
module.exports = {"page":"Packs_page__3qwbU page_page__31uF2"};